import { ModelCategory, WorkLine } from '@paragon/contract-library';

import { ModelSchema } from '../ModelSchema';
import { RoofPlaneSchema } from './RoofPlaneSchema';

export const WorkLineSchema = new ModelSchema<WorkLine>('workLine', {
  category: ModelCategory.IntermediateModel,

  pluralName: 'Work Lines',
  displayName(line) {
    return line.name;
  },

  properties: {},
  children: {
    roofPlanes: RoofPlaneSchema,
  },
});
